export default __webpack_public_path__ + "static/media/Scope-12.080d0738.png";